/* NOOKWAVE 2.0 — progressive enhancement only. Every feature has a no-JS fallback. */
(() => {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  let data = {};
  try { data = JSON.parse($('#ThemeData')?.textContent || '{}'); } catch (_) { data = {}; }
  const msg = data.messages || {};
  const rootUrl = (data.root || window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const url = path => rootUrl + path;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Money ---------- */
  function money(cents) {
    const value = Number(cents || 0) / 100;
    const fmt = String(data.moneyFormat || '').replace(/<[^>]*>/g, '');
    const match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    const presentment = window.Shopify?.currency?.active;
    const base = data.shopCurrency;
    if (!match || (presentment && base && presentment !== base)) {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: presentment || data.currency || 'USD' }).format(value); }
      catch (_) { return value.toFixed(2); }
    }
    const group = (num, decimals, thousands, decimal) => {
      const [int, dec] = num.toFixed(decimals).split('.');
      return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (dec ? decimal + dec : '');
    };
    const map = {
      amount: [2, ',', '.'],
      amount_no_decimals: [0, ',', '.'],
      amount_with_comma_separator: [2, '.', ','],
      amount_no_decimals_with_comma_separator: [0, '.', ','],
      amount_with_apostrophe_separator: [2, "'", '.'],
      amount_no_decimals_with_space_separator: [0, ' ', ','],
      amount_with_space_separator: [2, ' ', ','],
      amount_with_period_and_space_separator: [2, ' ', '.']
    };
    const [d, t, s] = map[match[1]] || map.amount;
    return fmt.replace(match[0], group(value, d, t, s));
  }

  /* ---------- Countdown (real sales only; hidden unless valid + future) ---------- */
  $$('[data-countdown]').forEach(el => {
    const end = Date.parse(el.dataset.countdown);
    if (!end || end <= Date.now()) { el.remove(); return; }
    const out = $('[data-countdown-time]', el);
    const pad = n => String(n).padStart(2, '0');
    let timer;
    const tick = () => {
      let s = Math.floor((end - Date.now()) / 1000);
      if (s <= 0) { clearInterval(timer); el.remove(); return; }
      const d = Math.floor(s / 86400); s %= 86400;
      const h = Math.floor(s / 3600); s %= 3600;
      const m = Math.floor(s / 60); s %= 60;
      out.textContent = `${d ? d + (msg.d || 'd') + ' ' : ''}${pad(h)}${msg.h || 'h'} ${pad(m)}${msg.m || 'm'} ${pad(s)}${msg.s || 's'}`;
    };
    tick();
    el.hidden = false;
    timer = setInterval(tick, 1000);
  });

  /* ---------- Mobile nav ---------- */
  const mobileNav = $('[data-mobile-nav]');
  if (mobileNav) {
    $$('a', mobileNav).forEach(a => a.addEventListener('click', () => mobileNav.removeAttribute('open')));
    document.addEventListener('click', e => { if (mobileNav.open && !mobileNav.contains(e.target)) mobileNav.removeAttribute('open'); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && mobileNav.open) { mobileNav.removeAttribute('open'); $('summary', mobileNav).focus(); } });
  }

  /* ---------- Gallery ---------- */
  $$('[data-gallery]').forEach(gallery => {
    const track = $('[data-gallery-track]', gallery);
    if (!track) return;
    const slides = $$('[data-gallery-slide]', track);
    const thumbs = $$('[data-gallery-thumb]', gallery);
    const thumbsWrap = $('[data-gallery-thumbs]', gallery);
    const prev = $('[data-gallery-prev]', gallery);
    const next = $('[data-gallery-next]', gallery);
    const current = $('[data-gallery-current]', gallery);
    let index = -1;

    const warm = i => { const img = slides[i] && $('img', slides[i]); if (img && img.loading === 'lazy') img.loading = 'eager'; };
    const sync = () => {
      const i = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
      if (i === index) return;
      index = i;
      thumbs.forEach((t, n) => t.setAttribute('aria-current', String(n === i)));
      if (current) current.textContent = i + 1;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      warm(i + 1); warm(i - 1);
      const thumb = thumbs[i];
      if (thumb && thumbsWrap) {
        const left = thumb.offsetLeft - (thumbsWrap.clientWidth - thumb.clientWidth) / 2;
        thumbsWrap.scrollTo({ left, behavior: reducedMotion ? 'auto' : 'smooth' });
      }
    };
    const go = i => {
      const target = slides[Math.max(0, Math.min(slides.length - 1, i))];
      if (target) track.scrollTo({ left: target.offsetLeft, behavior: reducedMotion ? 'auto' : 'smooth' });
    };
    let raf;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    thumbs.forEach((t, n) => t.addEventListener('click', () => { warm(n); go(n); }));
    prev?.addEventListener('click', () => go(index - 1));
    next?.addEventListener('click', () => go(index + 1));
    track.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
    });
    window.addEventListener('resize', () => { const i = index; index = -1; go(i); sync(); });
    gallery.goTo = go;
    sync();
  });

  /* ---------- Bag drawer ---------- */
  const drawer = $('#BagDrawer');
  let returnFocus = null;

  async function fetchCart() {
    const r = await fetch(url('cart.js'), { headers: { Accept: 'application/json' } });
    if (!r.ok) throw new Error('cart');
    return r.json();
  }

  function sizedImage(src, width) {
    if (!src) return '';
    return src + (src.includes('?') ? '&' : '?') + 'width=' + width;
  }

  function paintCount(count) { $$('[data-cart-count]').forEach(el => { el.textContent = count; }); }

  function paintShipBar(container, total) {
    if (!container) return;
    const baseGoal = Number(drawer?.dataset.goal || 0);
    if (!baseGoal) { container.hidden = true; return; }
    const goal = Math.round(baseGoal * Number(window.Shopify?.currency?.rate || 1));
    const remaining = goal - total;
    const text = $('[data-ship-text]', container);
    const fill = $('[data-ship-fill]', container);
    text.textContent = remaining > 0 ? (msg.shipRemaining || '').replace('{amount}', money(remaining)) : (msg.shipDone || '');
    fill.style.width = Math.min(100, Math.round((total / goal) * 100)) + '%';
    container.hidden = false;
  }

  function paintCart(cart) {
    paintCount(cart.item_count);
    if (!drawer) return;
    const list = $('[data-bag-items]', drawer);
    const foot = $('[data-bag-foot]', drawer);
    const status = $('[data-bag-status]', drawer);
    list.replaceChildren();
    (cart.items || []).forEach(item => {
      const li = document.createElement('li');
      li.className = 'drawer-line';

      const imgLink = document.createElement('a');
      imgLink.href = item.url;
      imgLink.tabIndex = -1;
      const img = document.createElement('img');
      img.src = item.image ? sizedImage(item.image, 160) : (drawer.dataset.fallbackImg || '');
      img.alt = '';
      img.width = 72; img.height = 72; img.loading = 'lazy';
      imgLink.append(img);

      const info = document.createElement('div');
      const title = document.createElement('a');
      title.className = 'drawer-line__title';
      title.href = item.url;
      title.textContent = item.product_title || item.title;
      info.append(title);
      if (item.variant_title && !item.product_has_only_default_variant) {
        const meta = document.createElement('p');
        meta.className = 'drawer-line__meta';
        meta.textContent = item.variant_title;
        info.append(meta);
      }
      (item.line_level_discount_allocations || []).forEach(a => {
        const p = document.createElement('p');
        p.className = 'drawer-line__meta';
        p.textContent = `${a.discount_application?.title || ''} (−${money(a.amount)})`;
        info.append(p);
      });

      const controls = document.createElement('div');
      controls.className = 'drawer-line__controls';
      const qty = document.createElement('div');
      qty.className = 'qty';
      const minus = document.createElement('button');
      minus.type = 'button'; minus.innerHTML = '<svg class="icon" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>';
      minus.setAttribute('aria-label', msg.decrease || '−');
      const count = document.createElement('span');
      count.textContent = item.quantity;
      count.setAttribute('aria-live', 'polite');
      const plus = document.createElement('button');
      plus.type = 'button'; plus.innerHTML = '<svg class="icon" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
      plus.setAttribute('aria-label', msg.increase || '+');
      plus.disabled = item.quantity >= 10;
      minus.addEventListener('click', () => changeLine(item.key, item.quantity - 1));
      plus.addEventListener('click', () => changeLine(item.key, item.quantity + 1));
      qty.append(minus, count, plus);
      const remove = document.createElement('button');
      remove.type = 'button'; remove.className = 'drawer-line__remove';
      remove.textContent = msg.remove || 'Remove';
      remove.addEventListener('click', () => changeLine(item.key, 0));
      controls.append(qty, remove);
      info.append(controls);

      const price = document.createElement('p');
      price.className = 'drawer-line__price';
      if (item.original_line_price > item.final_line_price) {
        const was = document.createElement('s');
        was.textContent = money(item.original_line_price);
        price.append(was);
      }
      price.append(document.createTextNode(money(item.final_line_price)));

      li.append(imgLink, info, price);
      list.append(li);
    });
    status.textContent = cart.item_count ? '' : (msg.emptyBag || '');
    foot.hidden = !cart.item_count;
    $('[data-bag-total]', drawer).textContent = money(cart.total_price);
    paintShipBar($('[data-drawer-ship]', drawer), cart.total_price);
  }

  async function changeLine(key, quantity) {
    if (!drawer) return;
    drawer.classList.add('is-busy');
    try {
      const r = await fetch(url('cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, Math.min(10, quantity)) })
      });
      const cart = await r.json();
      if (!r.ok) throw new Error(cart.description || msg.error);
      paintCart(cart);
    } catch (err) {
      $('[data-bag-status]', drawer).textContent = err.message || msg.bagError;
    } finally {
      drawer.classList.remove('is-busy');
    }
  }

  async function openBag(cart) {
    if (!drawer || typeof drawer.showModal !== 'function') { window.location.href = data.cartUrl || url('cart'); return; }
    if (!drawer.open) {
      returnFocus = document.activeElement;
      drawer.showModal();
      document.documentElement.style.overflow = 'hidden';
    }
    if (cart) { paintCart(cart); return; }
    $('[data-bag-status]', drawer).textContent = msg.loadingBag || '';
    try { paintCart(await fetchCart()); }
    catch (_) { $('[data-bag-status]', drawer).textContent = msg.bagError || ''; }
  }

  if (drawer) {
    $$('[data-close-bag]', drawer).forEach(b => b.addEventListener('click', () => drawer.close()));
    drawer.addEventListener('close', () => { document.documentElement.style.overflow = ''; returnFocus?.focus?.(); });
    drawer.addEventListener('click', e => {
      if (e.target !== drawer) return;
      const r = drawer.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) drawer.close();
    });
    $$('.bag').forEach(link => link.addEventListener('click', e => {
      if (typeof drawer.showModal !== 'function') return;
      e.preventDefault();
      openBag();
    }));
  }

  /* ---------- Product forms ---------- */
  $$('[data-product-form]').forEach(form => {
    const jsonEl = $('[data-product-json]', form);
    if (!jsonEl) return;
    let product;
    try { product = JSON.parse(jsonEl.textContent); } catch (_) { return; }
    const section = form.closest('[data-product-section]') || document;
    const addBtn = $('[data-add]', form);
    const addLabel = $('[data-add-label]', form);
    const addPrice = $('[data-add-price]', form);
    const status = $('[data-form-status]', form);
    const variantLabel = $('[data-variant-label]', form);
    const priceBox = $('.buybox__price', section);
    const sticky = $('[data-sticky-atc]', section);
    const stickyBtn = sticky && $('[data-sticky-submit]', sticky);
    const stickyPrice = sticky && $('[data-sticky-price]', sticky);
    const stickyMsrp = sticky && $('[data-sticky-msrp]', sticky);
    const defaultLabel = addLabel ? addLabel.textContent.trim() : '';
    const gallery = $('[data-gallery]', section);
    let pending = false;

    const selectedVariant = () => {
      const input = $('[data-variant-input]:checked', form) || $('input[type="hidden"][data-variant-input]', form);
      return product.variants.find(v => String(v.id) === String(input?.value)) || product.variants[0];
    };
    const quantity = () => 1;

    function render() {
      const v = selectedVariant();
      if (!v) return;
      const q = quantity();
      const total = v.price;
      const unitWas = v.compare_at_price > v.price ? v.compare_at_price : 0;

      if (priceBox) {
        const now = $('[data-price]', priceBox);
        const was = $('[data-compare]', priceBox);
        const save = $('[data-save]', priceBox);
        const reference = $('[data-reference]', priceBox);
        if (now) now.textContent = money(v.price);
        if (was) { was.hidden = !unitWas; if (unitWas) was.textContent = money(unitWas); }
        if (reference) reference.hidden = !unitWas;
        if (save) { save.hidden = !unitWas; if (unitWas) save.textContent = save.dataset.saveTemplate.replace('__amount__', money(unitWas - v.price)); }
      }


      const disabled = pending || !v.available;
      addBtn.disabled = disabled;
      addLabel.textContent = pending ? (msg.adding || '…') : v.available ? defaultLabel : (msg.soldOut || msg.unavailable);
      addPrice.textContent = v.available && !pending ? money(total) : '';
      if (stickyBtn) { stickyBtn.disabled = disabled; stickyBtn.textContent = v.available ? defaultLabel : (msg.soldOut || msg.unavailable); }
      if (stickyPrice) stickyPrice.textContent = money(total);
      if (stickyMsrp) { stickyMsrp.hidden = !unitWas; if (unitWas) $('s', stickyMsrp).textContent = money(unitWas); }
      if (variantLabel) variantLabel.textContent = v.title;
    }

    function onVariantChange() {
      const v = selectedVariant();
      render();
      if (v && location.pathname.includes('/products/')) {
        const u = new URL(location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', u);
      }
      if (v && v.image && gallery?.dataset.gallery === 'product' && gallery.goTo) gallery.goTo(v.image - 1);
    }

    $$('[data-variant-input]', form).forEach(i => i.addEventListener('change', onVariantChange));

    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (pending) return;
      const v = selectedVariant();
      const q = quantity();
      if (!v?.available) { status.textContent = msg.unavailable || ''; return; }
      if (!Number.isInteger(q) || q < 1 || q > 10) { status.textContent = msg.invalidQuantity || ''; return; }
      pending = true;
      status.textContent = '';
      render();
      try {
        const r = await fetch(url('cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: q }] })
        });
        const body = await r.json().catch(() => ({}));
        if (!r.ok) throw Object.assign(new Error(body.description || msg.error), { confirmed: true });
        status.textContent = msg.added || '';
        form.dispatchEvent(new CustomEvent('nookwave:cart-added', { bubbles: true, detail: { variantId: v.id, quantity: q } }));
        let cart = null;
        try { cart = await fetchCart(); } catch (_) {}
        await openBag(cart || undefined);
      } catch (err) {
        status.textContent = err.confirmed ? err.message : (msg.network || '');
      } finally {
        pending = false;
        render();
      }
    });

    stickyBtn?.addEventListener('click', () => {
      if (typeof form.requestSubmit === 'function') form.requestSubmit(addBtn); else addBtn.click();
    });

    if (sticky && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.inert = !show;
      });
      io.observe(addBtn);
    }

    render();
  });

  /* ---------- Advertorial: reading progress + sticky CTA ---------- */
  const adv = $('[data-advertorial]');
  if (adv) {
    const body = $('[data-adv-body]', adv);
    const bar = $('[data-read-progress]');
    const stickyAdv = $('[data-sticky-adv]', adv);
    if (bar && body) {
      let raf;
      const update = () => {
        const rect = body.getBoundingClientRect();
        const total = rect.height - window.innerHeight * 0.6;
        const done = Math.min(1, Math.max(0, -rect.top / Math.max(1, total)));
        bar.style.transform = `scaleX(${done})`;
      };
      window.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
      update();
    }
    if (stickyAdv && 'IntersectionObserver' in window) {
      const hero = $('.adv-hero', adv);
      let pastHero = false;
      const visibleOffers = new Set();
      const sync = () => {
        const show = pastHero && visibleOffers.size === 0;
        stickyAdv.classList.toggle('is-visible', show);
        stickyAdv.inert = !show;
      };
      new IntersectionObserver(([e]) => { pastHero = !e.isIntersecting && e.boundingClientRect.top < 0; sync(); }).observe(hero);
      const offerIo = new IntersectionObserver(entries => {
        entries.forEach(e => { if (e.isIntersecting) visibleOffers.add(e.target); else visibleOffers.delete(e.target); });
        sync();
      });
      $$('.adv-offer', adv).forEach(o => offerIo.observe(o));
    }
  }
})();
